import React from 'react'

const Author = () => {
    return (
        <div className="author center white-text"> 
            <span><i className="fas fa-feather-alt"></i></span>Made by Yuhiaht
        </div>
    )
}

export default Author
